export default __webpack_public_path__ + "static/media/imgRating-3.8a52cc08.jpg";